/** EPN-80 — a reusable "something went wrong, here's a retry" notice. `friendlyErrorMessage` already
 * produces safe, user-facing copy (never a raw stack trace) — this component just gives that copy a
 * consistent home with an actual retry action, instead of every page hand-rolling its own error paragraph
 * with no recovery path. */
export function RetryableError({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <div className="retryable-error" role="alert">
      <p className="error">{message}</p>
      <button type="button" onClick={onRetry}>
        Try again
      </button>
    </div>
  );
}
